import { render, staticRenderFns } from "./DsExpenses.vue?vue&type=template&id=0b1f04b9&scoped=true"
import script from "./DsExpenses.vue?vue&type=script&lang=js"
export * from "./DsExpenses.vue?vue&type=script&lang=js"
import style0 from "./DsExpenses.vue?vue&type=style&index=0&id=0b1f04b9&prod&scoped=true&lang=css"
import style1 from "./DsExpenses.vue?vue&type=style&index=1&id=0b1f04b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1f04b9",
  null
  
)

export default component.exports